var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { fetchNotificationSettings, updateNotificationSettings } from '@/lib/api';
import { useI18n } from '@/lib/i18n';
import * as styles from './NotificationSettings.module.scss';
export var NotificationSettings = function (_a) {
    var clientId = _a.clientId, clientEmail = _a.clientEmail;
    var _b = useI18n(), t = _b.t, locale = _b.locale;
    var options = [
        { key: 'notify_project_created', icon: '📋', label: t.notifyProjectCreated, desc: t.notifyProjectCreatedDesc },
        { key: 'notify_project_status', icon: '🔄', label: t.notifyProjectStatus, desc: t.notifyProjectStatusDesc },
        { key: 'notify_invoice_created', icon: '💳', label: t.notifyInvoiceCreated, desc: t.notifyInvoiceCreatedDesc },
    ];
    var _c = useState({ notify_project_created: true, notify_project_status: true, notify_invoice_created: true }), settings = _c[0], setSettings = _c[1];
    var _d = useState(false), saving = _d[0], setSaving = _d[1];
    useEffect(function () { loadSettings(); }, [clientId]);
    var loadSettings = function () { return __awaiter(void 0, void 0, void 0, function () { var _a, err_1; return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 2, , 3]);
                _a = setSettings;
                return [4 /*yield*/, fetchNotificationSettings(clientId)];
            case 1:
                _a.apply(void 0, [_b.sent()]);
                return [3 /*break*/, 3];
            case 2:
                err_1 = _b.sent();
                console.error(err_1);
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    }); }); };
    var handleToggle = function (key) { return __awaiter(void 0, void 0, void 0, function () {
        var newSettings, err_2;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    newSettings = __assign(__assign({}, settings), (_a = {}, _a[key] = !settings[key], _a));
                    setSettings(newSettings);
                    setSaving(true);
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, updateNotificationSettings(clientId, (_b = {}, _b[key] = !settings[key], _b))];
                case 2:
                    _c.sent();
                    return [3 /*break*/, 5];
                case 3:
                    err_2 = _c.sent();
                    console.error(err_2);
                    setSettings(settings);
                    return [3 /*break*/, 5];
                case 4:
                    setSaving(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var noEmailMsg = locale === 'ru'
        ? 'У клиента не указан email. Добавьте email чтобы настроить уведомления.'
        : 'No email set for this client. Add an email to configure notifications.';
    var sendingTo = locale === 'ru' ? 'Отправляем на' : 'Sending to';
    if (!clientEmail) {
        return (_jsxs("div", { className: styles.wrapper, children: [_jsxs("div", { className: styles.title, children: ["\uD83D\uDCE7 ", t.notifications] }), _jsx("div", { className: styles.noEmail, children: noEmailMsg })] }));
    }
    return (_jsxs("div", { className: styles.wrapper, children: [_jsxs("div", { className: styles.title, children: ["\uD83D\uDCE7 ", t.notifications] }), _jsxs("div", { className: styles.subtitle, children: [sendingTo, " ", _jsx("strong", { children: clientEmail })] }), _jsx("div", { className: styles.optionsList, children: options.map(function (opt) { return (_jsxs("label", { className: styles.option, children: [_jsxs("div", { className: styles.optionLeft, children: [_jsx("span", { className: styles.optionIcon, children: opt.icon }), _jsxs("div", { children: [_jsx("div", { className: styles.optionLabel, children: opt.label }), _jsx("div", { className: styles.optionDesc, children: opt.desc })] })] }), _jsx("div", { className: "".concat(styles.toggle, " ").concat(settings[opt.key] ? styles.toggleOn : ''), onClick: function () { return handleToggle(opt.key); }, children: _jsx("div", { className: styles.toggleKnob }) })] }, opt.key)); }) }), saving && _jsx("div", { className: styles.savingHint, children: t.saving })] }));
};
